import { NodeField, NodeOutput, WebhookExecutionAnchor } from '@components/Flow/Nodes';
import { Flow } from '@store/async';

export type WorkflowData = {
  flow: Flow;
  nodes: DatabaseNode[];
  edges: DatabaseEdge[];
  modules?: Omit<WorkflowData, 'modules'>[];
};

export type DatabaseNode = {
  id: string;
  node_id: string;
  command_id: string;
  type: string; // node type
  trigger_type: string; // workflow trigger type
  positionx: number;
  positiony: number;
  width: number;
  output: NodeOutput;
  attributes: NodeField[];
  dynamicOutput: any; // last output stored for node in node_executions
  webhooks: WebhookExecutionAnchor[]; // webhooks associated with node
  version: string;
};

export type DatabaseModule = {
  authentication: string;
  created_at: string;
  created_by: string;
  description: string;
  flow_id: string;
  name: string;
  node_count: string;
  org_id: string;
  parameters: any[];
  public: boolean;
  service_id: string;
  service_path: string;
  trigger_type: string;
  updated_at: string;
  updated_by: string;
  user_id: string;
};

export type DatabaseEdge = {
  animated: boolean;
  flow_id: string;
  id: string;
  source: string;
  sourceHandle: string;
  style: {
    stroke: string;
    strokeWidth: string;
  };
  target: string;
  targetHandle: string;
  variant: string;
};

type ArticleContent = {
  type: string;
  title: string;
  description: string;
  body: string;
  author_id: string;
  state: string;
  created_at: number;
  updated_at: number;
  url: string;
};

type ArticleStatistics = {
  type: string;
  views: number;
  conversions: number;
  reactions: number;
  happy_reaction_percentage: number;
  neutral_reaction_percentage: number;
  sad_reaction_percentage: number;
};

type TranslatedContent = {
  [key: string]: ArticleContent;
};

export type IntercomArticle = {
  type: 'article';
  id: string;
  workspace_id: string;
  title: string;
  description: string | null;
  body: string | null;
  author_id: string;
  state: 'published' | 'draft';
  created_at: number;
  updated_at: number;
  url: string;
  parent_id: string | null;
  parent_ids: number[];
  parent_type: string | null;
  default_locale: string;
  collection?: string;
  translated_content: TranslatedContent | null;
  statistics: ArticleStatistics | null;
};

export type SlackFile = any;

export type ContentfulArticle = {
  slug: string;
  file: string;
  filename: string;
  contentType: string;
};

export type IntercomFile = {
  event: DocumentEvent;
  lastModified: number;
  path: string;
  name: string;
  size: number;
  type: string;
  webkitRelativePath: string;
  body: IntercomArticle;
};

export type LoadableDocument = IntercomFile;

export enum DocumentLoaders {
  Intercom = 'intercom',
  Contentful = 'contentful',
  Devdocs = 'devdocs',
  Guru = 'guru',
  Slack = 'slack',
}

export enum DocumentEvent {
  Upload = 'upload',
  Embed = 'embed',
  Loader = 'loader',
}
